module.exports = __webpack_public_path__ + "assets/media/app-store-about.01abfaca.svg";